"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LogLevelLogger {
    constructor(name, logLevelLogProvider) {
        this.error = (error, message, ...optionalParams) => {
            this.init();
            if (this._implLogger)
                this._implLogger.error(error, message, optionalParams);
        };
        this.warn = (message, ...optionalParams) => {
            this.init();
            if (this._implLogger)
                this._implLogger.warn(message, optionalParams);
        };
        this.info = (message, ...optionalParams) => {
            this.init();
            if (this._implLogger)
                this._implLogger.info(message, optionalParams);
        };
        this.debug = (message, ...optionalParams) => {
            this.init();
            if (this._implLogger)
                this._implLogger.debug(message, optionalParams);
        };
        this.trace = (message, ...optionalParams) => {
            this.init();
            if (this._implLogger)
                this._implLogger.trace(message, optionalParams);
        };
        this.name = name;
        this._logLevelLogProvider = logLevelLogProvider;
        this.init();
    }
    get isDebugEnabled() {
        return this._implLogger.getLevel() <= 1;
    }
    init() {
        if (this._implLogger)
            return;
        const loggerProvider = this._logLevelLogProvider();
        if (!loggerProvider)
            return;
        const impLogger = loggerProvider.getLogger(this.name);
        if (!impLogger) {
            console.warn("Can't get logger.");
            return;
        }
        this._implLogger = impLogger;
        this.error = this._implLogger.error;
        this.warn = this._implLogger.warn;
        this.info = this._implLogger.info;
        this.debug = this._implLogger.debug;
        this.trace = this._implLogger.trace;
    }
    // error(messageProvider: Func0<string>, error?: Error, callerMemberName?: string): void {
    //   const errorMessage = error ? error.message : "";
    //   const errorMessageWithPrefix = errorMessage + ", " + ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName);
    //   console.error(errorMessageWithPrefix);
    //   console.trace(errorMessageWithPrefix);
    //   //console.error(errorMessage + ", " + ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName));
    // }
    // warn(messageProvider: Func0<string>, callerMemberName?: string): void {
    //   console.warn(ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName));
    // }
    // info(messageProvider: Func0<string>, callerMemberName?: string): void {
    //   console.info(ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName));
    // }
    // debug(messageProvider: Func0<string>, callerMemberName?: string): void {
    //   console.debug(ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName));
    // }
    // trace(messageProvider: Func0<string>, callerMemberName?: string): void {
    //   console.debug(ConsoleLogger.GenLogWithCallerPrefix(messageProvider, callerMemberName));
    // }
    static GenLogWithCallerPrefix(messageGen, methodName) {
        if (methodName)
            return `${methodName}: ${messageGen()}`;
        else
            return `${messageGen()}`;
    }
}
exports.LogLevelLogger = LogLevelLogger;
//# sourceMappingURL=LogLevelLogger.js.map